import Routes from '@/router/routes';

const PROJECT_PAGES = [
  Routes.project_design.path,
  Routes.project_results.path,
  Routes.project_share.path,
];

/**
 * Checks if the current pathname corresponds to a project page
 * @param pathname - The current location pathname
 * @returns true if the current page is a project page, false otherwise
 */
export const isProjectPage = (pathname: string): boolean =>
  PROJECT_PAGES.some((path) => pathname.includes(path));
